"use client"
import { trackPageView } from "@/actions/_archive/global/analytics/trackPageView"
import { useEffect } from "react"

export function useTrackPageView(pageName: string | null) {
  useEffect(() => {
    if (!pageName) return
    trackPageView(window.location.pathname, pageName)
  }, [pageName])
}
